import { render, staticRenderFns } from "./Regulation.vue?vue&type=template&id=3654ab85&scoped=true&"
import script from "./Regulation.js?vue&type=script&lang=js&"
export * from "./Regulation.js?vue&type=script&lang=js&"
import style0 from "./Regulation.scss?vue&type=style&index=0&id=3654ab85&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3654ab85",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
